import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Sidebar({ open, close }) {
  const { pathname } = useLocation();
  const [gamesOpen, setGamesOpen] = useState(
    pathname.includes("/admin/adminManageTitli") ||
      pathname.includes("/admin/adminManageLucky7") ||
      pathname.includes("/admin/adminManageMatkaList") ||
      pathname.includes("/admin/wingo") ||
      pathname.includes("/admin/minesGame") ||
      pathname.includes("/admin/AdminSpinWheel") ||
      pathname.includes("/admin/AdminAviator"),
  );

  const [financeOpen, setFinanceOpen] = useState(
      pathname.includes("/admin/pendingDeposite") ||
      pathname.includes("/admin/pendingWithdraw") ||
      pathname.includes("/admin/reports") || 
      pathname.includes("/admin/api/reports")
      ,
  );

  return (
    <>
      <div className={`sidebar1 p-3 ${open ? "" : "mobile-hide"}`}>
        <h4 className="mb-4">🚀 Admin</h4>

        <Link
          className={pathname === "/admin/dashboard" ? "active" : ""}
          to="/admin/dashboard"
        >
          <i className="bi bi-speedometer2 me-2"></i>Dashboard
        </Link>

        <Link
          className={pathname === "/admin/users" ? "active" : ""}
          to="/admin/users"
        >
          <i className="bi bi-person me-2"></i>Users
        </Link>

        {/* Finance Dropdown */}
        <div
          className="sidebar-dropdown"
          onClick={() => setFinanceOpen(!financeOpen)}
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex align-items-center">
            <i className="bi bi-cash me-2"></i> Finance
            <i
              className={`bi ms-auto ${
                financeOpen ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
        </div>

        {financeOpen && (
          <div className="submenu">
            <Link
              className={pathname === "/admin/pendingDeposite" ? "active" : ""}
              to="/admin/pendingDeposite"
            >
              <i className="bi bi-cash me-2"></i> Pending Deposite
            </Link>
            <Link
              className={pathname === "/admin/pendingWithdraw" ? "active" : ""}
              to="/admin/pendingWithdraw"
            >
              <i className="bi bi-cash me-2"></i> Pending Withdraw
            </Link>
            <Link
              className={pathname === "/admin/reports" ? "active" : ""}
              to="/admin/reports"
            >
              <i className="bi bi-cash me-2"></i> Reports
            </Link>
            <Link
              className={pathname === "/admin/api/reports" ? "active" : ""}
              to="/admin/api/reports"
            >
              <i className="bi bi-cash me-2"></i> Api Reports
            </Link>
          </div>
        )}

        {/* Games Dropdown */}
        <div
          className="sidebar-dropdown"
          onClick={() => setGamesOpen(!gamesOpen)}
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex align-items-center">
            <i className="bi bi-controller me-2"></i> Games
            <i
              className={`bi ms-auto ${
                gamesOpen ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
        </div>

        {gamesOpen && (
          <div className="submenu">
            <Link
              className={pathname === "/admin/adminManageAviator" ? "active" : ""}
              to="/admin/adminManageAviator"
            >
              <i className="bi bi-airplane me-2"></i> Aviator
            </Link>

            <Link
              className={pathname === "/admin/adminManageTitli" ? "active" : ""}
              to="/admin/adminManageTitli"
            >
              <i className="bi bi-bug me-2"></i> Titli
            </Link>

            <Link
              className={
                pathname === "/admin/adminManageLucky7" ? "active" : ""
              }
              to="/admin/adminManageLucky7"
            >
              <i className="bi bi-dice-5 me-2"></i> Lucky7
            </Link>

            <Link
              className={
                pathname === "/admin/adminManageK3" ? "active" : ""
              }
              to="/admin/adminManageK3"
            >
              <i className="bi bi-dice-5 me-2"></i> K3
            </Link>

            <Link
              className={
                pathname === "/admin/adminManage5d" ? "active" : ""
              }
              to="/admin/adminManage5d"
            >
              <i className="bi bi-dice-5 me-2"></i> 5D
            </Link>

            <Link
              className={
                pathname === "/admin/adminManageMatkaList" ? "active" : ""
              }
              to="/admin/adminManageMatkaList"
            >
              <i className="bi bi-collection-play me-2"></i> Matka Game
            </Link>

            <Link
              className={pathname === "/admin/wingo" ? "active" : ""}
              to="/admin/wingo"
            >
              <i className="bi bi-grid-3x3-gap-fill me-2"></i> Wingo
            </Link>

            <Link
              className={pathname === "/admin/minesGame" ? "active" : ""}
              to="/admin/minesGame"
            >
              <i className="bi bi-gem me-2"></i> Mines Game
            </Link>

            <Link
              className={pathname === "/admin/AdminSpinWheel" ? "active" : ""}
              to="/admin/AdminSpinWheel"
            >
              <i className="bi bi-arrow-repeat me-2"></i> Spin Game
            </Link>
          </div>
        )}

        <Link
          className={pathname === "/admin/payment-settings" ? "active" : ""}
          to="/admin/payment-settings"
        >
          <i className="bi bi-wallet me-2"></i>Payment Settings
        </Link>
      </div>

      {open && <div className="overlay d-lg-none" onClick={close}></div>}
    </>
  );
}
